require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./chocolate-chip-cookie-dough.json") })
        }
      }, "path---chocolate-chip-cookie-dough");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---chocolate-chip-cookie-dough!./.cache/json/chocolate-chip-cookie-dough.json
// module id = 479
// module chunks = 231608221292675